<div>
  <small>* The following will will be changed upon overriding</small>
  <div class="grid">
    <div class="col-12 md:col-6 flex flex-column">
      <div>
        <h3>Status</h3>
      </div>

      <div class="">
        <p-tag value="COMPLETED" severity="success" styleClass=""></p-tag>
      </div>
    </div>

    <div class="col-12 md:col-6 flex flex-column">
      <div>
        <h3>Transaction Method</h3>
      </div>
      <div class="">
        <label for="description" class="text-gray-800">Override</label>
      </div>
    </div>
    <div class="col-12 flex flex-column">
      <div>
        <h3>Transaction Date</h3>
      </div>
      <div class="">
        <p-calendar
          [(ngModel)]="selectedDate"
          [showIcon]="true"
          [inputStyle]="{ width: '100%' }"
          [monthNavigator]="true"
          [showOnFocus]="true"
          appendTo="body"
          dateFormat="yy-mm-dd"
          styleClass="w-full"
        ></p-calendar>
      </div>
    </div>
    <div class="col-12 flex flex-column">
      <div>
        <h3>Override Reason</h3>
      </div>
      <div class="">
        <p-dropdown
          [(ngModel)]="selectedReason"
          [options]="overrideReasons"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Reason"
          appendTo="body"
          styleClass="w-full"
        ></p-dropdown>
      </div>
    </div>
    <div class="surface-border border-top-1 opacity-50 mt-3 col-12"></div>
    <div class="col-12">
      <button
        *appHasPermission="'transactions.override'"
        pButton
        label="Override"
        class="w-full p-button-primary"
        (click)="overrideTransaction()"
        [loading]="loading"
      ></button>
    </div>
  </div>
</div>
